import clsx from "clsx";
import Container from "./Container";
import kpLogo from "../media/investors/kp.png";
import ycLogo from "../media/investors/yc.png";
import gfcLogo from "../media/investors/gfc.png";

type SectionProps = {
  className?: string;
};

const Investors = ({ className }: SectionProps) => {
  return (
    <section id="investors" className={clsx("pb-12", className)}>
      <Container>
        <div className="grid grid-cols-1 md:grid-cols-3 place-items-center gap-16 md:gap-24">
          <div className="h-12">
            <img
              src={ycLogo}
              alt="Y Combinator"
              className="h-full w-auto object-contain max-w-none shrink-0"
              loading="lazy"
            />
          </div>
          <div className="h-6">
            <img
              src={kpLogo}
              alt="Kleiner Perkins"
              className="h-full w-auto object-contain max-w-none shrink-0"
              loading="lazy"
            />
          </div>
          <div className="h-6">
            <img
              src={gfcLogo}
              alt="GFC"
              className="h-full w-auto object-contain max-w-none shrink-0"
              loading="lazy"
            />
          </div>
        </div>
      </Container>
    </section>
  );
};

export default Investors;


